import toast from 'react-hot-toast';
import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../../../../constants/ActionNameConstants';
import { STATE_API_URL } from '../../../../../../constants/ApiUrlConstants';
import { getApiRequest } from '../../../../../../features/axiosClient';
import { stateListFailure, stateListSuccess } from '../actions';

const stateListAPI = (action) => getApiRequest(`${STATE_API_URL}?CountryId=${action}`);

function* handleStateListAPI(action) {
  try {
    const response = yield call(stateListAPI, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    yield put(stateListSuccess(response));
  } catch (error) {
    yield put(stateListFailure(error));
  }
}

export function* watchGetStateList() {
  yield takeLatest(types.EDIT_STATE_REQUEST, handleStateListAPI);
}
